<template>
  <base-material-card
    class="px-4 py-3"
    color="bgTank"
    icon="mdi-octagon"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light text-start v-card--material__heading mb-n6 v-sheet theme--dark elevation-6 bgTank pa-8">
        {{ $t("tanks-set.current-status") }}
        <span class="subtitle-1">— {{ tankCurretStatus.targetDeviceDescription }}</span>
      </div>
    </template>
    <v-row>
      <v-col
        cols="12"
        md="5"
      >
        <h3 class="info--text">
          {{ $t('tanks-set.registerAt') }}:
        </h3>
      </v-col>
      <v-col
        cols="12"
        md="7"
      >
        <h3 class="font-weight-bold">
          {{ tankCurretStatus.registerAt | formatLongDate }}
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <progress-bar
        class="d-sm-none pl-3"
        :value="tankValue"
        :options="options"
      />
      <tank-bar
        class="d-none d-sm-flex"
        :value="tankValue"
      />
    </v-row>
    <v-row justify="center">
      <v-col
        cols="12"
        md="4"
        sm="3"
        lg="4"
      >
        <v-card class="ma-0">
          <v-card-title class="">
            {{ $t('tanks-set.gallons') }}
          </v-card-title>
          <v-card-text>
            <span class="subtitle-1"><span class="headline">{{ tankCurretStatus.currentGallons }}</span></span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="3"
        lg="4"
      >
        <v-card class="ma-0">
          <v-card-title class="">
            {{ $t('tanks-set.liters') }}
          </v-card-title>
          <v-card-text>
            <span class="subtitle-1"><span class="headline">{{ tankCurretStatus.currentLiters }}</span></span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="6"
        lg="4"
      >
        <v-card class="ma-0">
          <v-card-title class="">
            {{ $t('tanks-set.percentage') }}
          </v-card-title>
          <v-card-text>
            <span class="subtitle-1"><span class="headline">{{ tankCurretStatus.percentage }} %</span> </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </base-material-card>
</template>

<script>
  import filters from '@/common/filters'
  import ProgressBar from 'vuejs-progress-bar'
  import TankBar from '@/components/tankGraphs/TankBar'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const tanksRespository = repositoryFactory.get('tanks')

  export default {
    name: 'TankStateView',
    components: { TankBar, ProgressBar },
    mixins: [filters],
    props: {
      targetDeviceId: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        tankValue: 0,
        tankCurretStatus: {
          targetDevice: {},
        },
        showErrorMessage: false,
        errorMessage: '',
        polling: null,
        options: {
          text: {
            color: '#000000',
            shadowEnable: true,
            shadowColor: '#000000',
            fontSize: 14,
            fontFamily: 'Helvetica',
            dynamicPosition: false,
            hideText: false,
          },
          progress: {
            color: '#E8E8E8',
            backgroundColor: '#2a7fff',
          },
          layout: {
            height: 35,
            width: 140,
            verticalTextAlign: 61,
            horizontalTextAlign: 43,
            zeroOffset: 0,
            strokeWidth: 30,
            progressPadding: 0,
            type: 'cylinder',
          },
        },
      }
    },
    mounted () {
      var self = this
      self.fetchData(self.targetDeviceId)
      self.polling = setInterval(function () { self.fetchData(self.targetDeviceId) }, 1 * 60 * 1000)
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      fetchData (targetDeviceId) {
        var self = this
        tanksRespository.getCurrent(targetDeviceId).then(response => {
          self.tankCurretStatus = response.data.data
          self.tankValue = self.tankCurretStatus.percentage
        }).catch(err => {
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
    },
  }
</script>

<style>
.bgTank{
  background-color: #023A66 !important;
}
</style>
